import { render, staticRenderFns } from "./PopUpPrompt.vue?vue&type=template&id=1ff2948d&scoped=true"
import script from "./PopUpPrompt.vue?vue&type=script&lang=js"
export * from "./PopUpPrompt.vue?vue&type=script&lang=js"
import style0 from "./PopUpPrompt.vue?vue&type=style&index=0&id=1ff2948d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff2948d",
  null
  
)

export default component.exports